import { useNavigate, useParams } from 'react-router-dom';
import { questions } from '../../config/data';
import GlobalStatusController from './GlobalStatusController';

const QuestionNavigation = () => {
    const navigate = useNavigate();
    const { qSetKey, questionTitle } = useParams(); // Extract qSetKey and questionTitle from URL

    const questionSet = questions[qSetKey]; // Get the question set
    const currentQuestion = questionSet?.list.find((q) => q.title === questionTitle);

    if (!currentQuestion) {
        return <div>Error: Question not found.</div>; // Handle invalid question/title
    }

    const handlePrevious = () => {
        const prevQuestion = questionSet.list.find((q) => q.id === currentQuestion.id - 1);
        if (prevQuestion) {
            navigate(`/game/${qSetKey}/${prevQuestion.title}`); 
        }
    };

    const handleNext = () => {
        const nextQuestion = questionSet.list.find((q) => q.id === currentQuestion.id + 1); 
        if (nextQuestion) {
            navigate(`/game/${qSetKey}/${nextQuestion.title}`);
        }
    };


    return (
        <div className="question-navigation">
            <button
                onClick={handlePrevious}
                disabled={currentQuestion.id === 1} // Disable if it's the first question
            >
                Prev
            </button>

            <GlobalStatusController/>

            <button
                onClick={handleNext}
                disabled={currentQuestion.id === questionSet.list.length} // Disable if it's the last question
            >
                Next
            </button>
        </div>
    );
};

export default QuestionNavigation;
